// Sayfa bileşeni çağırır: geçerli yolun breadcrumb son parçası `label` olur (boşsa "Detay").
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useBreadcrumbStore } from "../stores/breadcrumb-store";

export function useBreadcrumbDetail(label: string | null | undefined): void {
  const { pathname } = useLocation();
  useEffect(() => {
    const text = label?.trim();
    if (!text) return;
    const store = useBreadcrumbStore.getState();
    store.setDetail(pathname, text);
    return () => useBreadcrumbStore.getState().clearDetail(pathname);
  }, [pathname, label]);
}
